import React, { useState } from 'react';
import styled from '@emotion/styled';
import moment from 'moment';

const Wrapper = styled('div')`
  padding-left: 0;
  padding-right: 0;
  font-size: 13px;
  margin-top: 20px;
  background: white;

  .header-title {
    padding: 16px;
    margin: 0;
    border-bottom: 1px solid #f1f5f8;
  }

  .card-content {
    padding: 16px 16px 16px 23px;
  }

  .order-history-wrapper {
    display: flex;
    color: #9698a0;
    .order-history-date {
      min-width: 120px;
      width: 120px;
      margin-right: 16px;
      font-size: 12px;
    }
    .order-history-status {
      position: relative;
      color: #72747b;
      padding-left: 20px;
      border-left: 3px solid #d0d0d0;
      padding-bottom: 30px;
      min-width: 120px;
      margin-right: 18px;
      &:before {
        content: '';
        position: absolute;
        left: -9px;
        top: 0;
        border: 3px solid #d0d0d0;
        border-radius: 50%;
        width: 14px;
        height: 14px;
        background-color: white;
      }

      .order-history-status-title {
        font-weight: bold;
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      .order-history-date {
        margin-left: 10px;
        font-weight: normal;
        white-space: nowrap;
        font-weight: 12px;
      }
    }
    .order-histoty-text {
      //margin-right: 18px;
      min-width: 250px;
      .order-history-subtype {
        color: #72747b;
      }
    }
    .order-history-description {
      margin-bottom: 10px;
      color: #9698a0;
    }
    .order-history-icon {
      margin-left: auto;
      font-size: 15px;
      color: #d6d6d6;
    }

    &:not(.full-mode):last-child {
      .order-history-status {
        padding-bottom: 0;
        margin-bottom: -20px;
      }
    }

    &.full-mode:last-child {
      .order-history-status {
        border-left: none;
        &:before {
          left: -6px;
        }
      }
    }
  }
  .more-link {
    display: flex;
    padding-top: 9px;
    border-top: 1px solid #f1f5f8;
    margin-top: -10px;
    padding-left: 0;
    padding-right: 0;
    padding: 12px;
    display: flex;
    justify-content: center;
    position: relative;
    background: white;

    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 150px;
      left: 0;
      top: -151px;
      background: linear-gradient(to top, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
    }
  }
`;

const MobileHistoryBlock = (props) => {
  const { orderHistory } = props;

  const [fullMode, setFullState] = useState(false);

  const filteredData = fullMode
    ? orderHistory.slice().reverse()
    : orderHistory.slice().reverse().slice(0, 3);

  return (
    <Wrapper>
      <div>
        <h4 className="header-title">История заказа</h4>
      </div>
      <div className="card-content">
        {filteredData.map((h) => (
          <div key={h.id} className={`order-history-wrapper ${fullMode ? 'full-mode' : ''}`}>
            <div className="order-history-status">
              <div className="order-history-status-title">
                {h.orderDocStage}
                <div className="order-history-date ">
                  {moment(h.eventDate).format('DD MMM YYYY HH:mm:ss')}
                </div>
              </div>
              <div className="order-histoty-text">
                <div className="order-history-subtype">{h.subType}</div>
                {h.description ? (
                  <div className="order-history-description">{h.description}</div>
                ) : null}
              </div>
            </div>
          </div>
        ))}
      </div>
      {!fullMode ? (
        <div className="more-link" onClick={() => setFullState(true)}>
          Полная история
        </div>
      ) : null}
    </Wrapper>
  );
};

export default MobileHistoryBlock;
